import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

import { SignupAttribution } from '../model/signupAttribution';

export type GetUserTokenWithCodePayload = {
  email: string;
  signup_access_code?: string;
  first_name?: string;
  last_name?: string;
  phone_number?: string;
  company_name?: string;
  company_website?: string;
  monthly_revenue?: string;
  job_title?: string;
  agreed_to_terms: boolean;
  timezone?: string;
} & Partial<SignupAttribution>;
type GetUserTokenWithCodeResponse = any;

export const getUserTokenWithCode = async (
  payload: GetUserTokenWithCodePayload
): Promise<GetUserTokenWithCodeResponse> => {
  try {
    const { data } = await apiService.post<GetUserTokenWithCodeResponse>(
      '/users',
      payload
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error, { silent: true });
  }
};
